import { HttpContext } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'

import { DISABLE_GLOBAL_EXCEPTION_HANDLING } from '../../interceptors/error.interceptor'
import { Snapshot, SnapshotDownload } from '../../models/snapshot.model'
import { BaseRepository } from '../base.repository'

@Injectable({
  providedIn: 'root',
})
export class SnapshotRepository extends BaseRepository<Snapshot> {
  public constructor() {
    super({
      resourceName: 'snapshots',
      defaultSorting: [{ property: 'createdAt', direction: 'asc' }],
    })
  }

  public create(item: Partial<Snapshot>): Observable<unknown> {
    return this.http.post<unknown>(this.url, item, {
      context: new HttpContext().set(DISABLE_GLOBAL_EXCEPTION_HANDLING, true),
    })
  }

  public downloadCSV(id: string): void {
    this.http
      .get<SnapshotDownload>(`${this.url}/${id}/export`)
      .subscribe((res) => {
        const downloadLink = document.createElement('a')
        downloadLink.href = res.downloadUrl
        document.body.appendChild(downloadLink)
        downloadLink.click()
        downloadLink.remove()
      })
  }
}
